// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nimg[data-v-3a86191f]{\n  max-width:200px;\n}\n", ""]);
// Exports
module.exports = exports;
